/* Dynamic Instruments — comportamiento del tema
   Porta del prototipo: toggle de tema, toggle ES/EN, reveal on scroll,
   acordeon FAQ y el comparador de audio 3 ejemplos x 3 modos. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ tema */
  var THEME_KEY = 'di-theme';

  function applyTheme(t) {
    document.documentElement.setAttribute('data-di-theme', t);
    try { localStorage.setItem(THEME_KEY, t); } catch (e) {}
    document.querySelectorAll('[data-di-theme-text]').forEach(function (el) {
      el.textContent = t === 'dark' ? 'DARK' : 'LIGHT';
    });
  }

  function initTheme() {
    var saved = null;
    try { saved = localStorage.getItem(THEME_KEY); } catch (e) {}
    applyTheme(saved === 'light' || saved === 'dark' ? saved : 'dark');
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-di-theme-toggle]')) return;
      var cur = document.documentElement.getAttribute('data-di-theme');
      applyTheme(cur === 'dark' ? 'light' : 'dark');
    });
  }

  /* ------------------------------------------------------------- idioma ES */
  var ES = {
    'Plugins': 'Plugins',
    'Support': 'Soporte',
    'Get started': 'Empezar',
    '01 / SIDECHAIN — INTRODUCING SID': '01 / SIDECHAIN — PRESENTAMOS SID',
    'Make your bassline breathe.': 'Hacé que tu línea de bajos tenga vida.',
    'Every sidechain plugin ducks the same on every beat. SID lets each one breathe differently, longer here, tighter there, locked to your grid.': 'Todos los plugins de sidechain hunden igual en cada beat. SID hace que cada uno respire distinto, más largo acá, más corto allá, anclado a tu grid.',
    'Example 1': 'Ejemplo 1',
    'Example 2': 'Ejemplo 2',
    'Example 3': 'Ejemplo 3',
    'No sidechain': 'Sin sidechain',
    'Every beat ducks the same': 'Cada beat hunde igual',
    'Each beat breathes differently': 'Cada beat respira distinto',
    'Same loop, same curve, same depth. The only difference is the pattern.': 'Mismo loop, misma curva, misma profundidad. La única diferencia es el patrón.',
    'Explore SID': 'Ver SID',
    'Watch in action': 'Verlo en acción',
    'Draw the pump.': 'Dibujá el pump.',
    'Sidechain shouldn’t sound like a compressor picking a fight with your kick. SID lets you draw the envelope step by step, editable points, tension per segment, so the ducking becomes part of the groove instead of an effect stapled on top.': 'El sidechain no debería sonar como un compresor peleándose con tu kick. SID te deja dibujar la envolvente paso a paso, puntos editables, tensión por segmento, para que el ducking sea parte del groove y no un efecto pegado encima.',
    '16-step pattern engine': 'Motor de patrones de 16 pasos',
    'A different pattern per step. No two bars alike.': 'Un patrón distinto por paso. Sin dos compases iguales.',
    'Editable curves': 'Curvas editables',
    'Points and tension per segment. The exact shape you want.': 'Puntos y tensión por segmento. La forma exacta que querés.',
    'Band + focus': 'Banda + focus',
    'Duck only the range that’s in the way. Leave the rest untouched.': 'Duckeá solo el rango que estorba. Dejá el resto intacto.',
    'PPQ-locked': 'Anclado al PPQ',
    'Nailed to the host tempo. Always in time.': 'Clavado al tempo del host. Siempre en tiempo.',
    'SID — grooving sidechain · plugin interface': 'SID — grooving sidechain · interfaz del plugin',
    'Technical specifications': 'Especificaciones técnicas',
    'FORMATS': 'FORMATOS',
    'PLATFORMS': 'PLATAFORMAS',
    'ARCHITECTURE': 'ARQUITECTURA',
    'SAMPLE RATES': 'FRECUENCIAS',
    'LATENCY': 'LATENCIA',
    'Zero': 'Cero',
    'Get SID': 'Comprar SID',
    'Windows 10+ — macOS coming soon': 'Windows 10+ — macOS próximamente',
    'MACOS — COMING SOON': 'MACOS — PRÓXIMAMENTE',
    'How do I install the plugins?': '¿Cómo instalo los plugins?',
    'Download the installer for your platform, run it, and it drops the VST3, plus the AU on macOS, into the standard folders. Rescan your DAW and the plugin appears. No account, no download manager.': 'Descargás el instalador de tu plataforma, lo corrés y deja el VST3, más el AU en macOS, en las carpetas estándar. Reescaneás el DAW y aparece. Sin cuenta ni gestor de descargas.',
    'How many machines does one license cover?': '¿Cuántas máquinas cubre una licencia?',
    'One license covers two machines you own. Activation is done online from the plugin.': 'Una licencia cubre dos máquinas tuyas. La activación se hace online desde el plugin.',
    'Is there a demo?': '¿Hay demo?',
    'Is it safe to pay here?': '¿Es seguro pagar acá?',
    'Checkout runs on Shopify, certified PCI DSS Level 1, the same standard banks are held to. Your card details travel encrypted straight to the payment processor and never reach our servers, so there is nothing on our side to leak. All prices are in USD. If something looks wrong at checkout, write to support@dyninstruments.com before trying again.': 'El checkout corre sobre Shopify, certificado PCI DSS Nivel 1, el mismo estándar que se le exige a un banco. Los datos de tu tarjeta viajan cifrados directo al procesador de pagos y nunca pasan por nuestros servidores, así que de nuestro lado no hay nada que filtrar. Todos los precios están en USD. Si algo no cuadra en el checkout, escribinos a support@dyninstruments.com antes de volver a intentar.',
    'Yes, 3 days. It runs on the same installer; enter a license key when you’re convinced.': 'Sí, 3 días. Usa el mismo instalador; ponés la licencia cuando te convenza.',
    'Are updates included?': '¿Las actualizaciones están incluidas?',
    'All updates inside the same major version are free, including new presets and OS compatibility releases. Sessions stay compatible across versions.': 'Todas las actualizaciones dentro de la misma versión mayor son gratis, incluidos presets nuevos y releases de compatibilidad. Las sesiones quedan compatibles entre versiones.',
    'What’s the refund policy?': '¿Cómo son los reembolsos?',
    'Company': 'Empresa',
    'Installation': 'Instalación',
    'Licenses': 'Licencias',
    'About': 'Nosotros',
    'Contact': 'Contacto',
    'Terms': 'Términos',
    'Release notes and presets. Nothing else.': 'Notas de versión y presets. Nada más.',
    'MADE FOR LOW END': 'HECHO PARA EL LOW END',

    /* ---- producto ---- */
    'Add to cart': 'Agregar al carrito',
    'Sold out': 'Agotado',
    'License': 'Licencia',
    'Instant download · Online activation': 'Descarga inmediata · Activación online',
    'Try for 3 days': 'Probar 3 días',

    /* ---- hero en celular ---- */
    'Hear the difference': 'Escuchá la diferencia',
    'One-time purchase': 'Pago único',
    'Buy on your phone. Download SID later on your computer.': 'Comprá desde el celular. Descargá SID después en tu computadora.',
    'Try SID free': 'Probá SID gratis',
    'Download it later on your Windows computer.': 'Descargalo después en tu computadora con Windows.',
    'Get the free demo': 'Obtené la demo gratis',
    'Free checkout. We\'ll email you the download link.': 'Checkout gratis. Te enviamos el link de descarga por email.',
    'MACOS COMING SOON': 'MACOS PRÓXIMAMENTE',
    'macOS coming soon': 'macOS próximamente',
    'Instant delivery': 'Entrega inmediata',
    'Instant download': 'Descarga inmediata',
    '2 activations': '2 activaciones',
    'Secure checkout': 'Pago seguro',
    'Language': 'Idioma',

    /* ---- reviews ---- */
    'What producers say': 'Lo que dicen los productores',
    'Used in real sessions.': 'Usado en sesiones reales.',
    'Producers using SID in their own music.': 'Productores usando SID en su propia música.',
    'Verified customer': 'Cliente verificado',
    'Purchased SID?': '¿Compraste SID?',
    'Share your experience.': 'Contanos tu experiencia.',
    'Share your experience with SID and get an exclusive discount on one of our upcoming plugins.': 'Contanos tu experiencia con SID y llevate un descuento exclusivo en uno de nuestros próximos plugins.',
    'Leave a review →': 'Dejar una review →',
    'Available to verified SID customers. Honest feedback is always welcome.': 'Para clientes verificados de SID. Siempre es bienvenida una opinión honesta.',
    'Email used to purchase SID': 'Email con el que compraste SID',
    'Name / Artist name': 'Nombre / Nombre artístico',
    'Instagram (optional)': 'Instagram (opcional)',
    'Your review': 'Tu review',
    'You may feature my review, artist name and profile picture on the Dynamic Instruments website and social media.': 'Autorizo a Dynamic Instruments a mostrar mi review, mi nombre artístico y mi foto de perfil en su web y sus redes.',
    'Submit review': 'Enviar review',
    'Sending…': 'Enviando…',
    'We\'ll verify your SID purchase using the email above before issuing your discount.': 'Vamos a verificar tu compra de SID con ese email antes de darte el descuento.',
    'Thank you! We\'ll verify your SID purchase and send your discount to your purchase email.': '¡Gracias! Vamos a verificar tu compra de SID y te enviamos el descuento al email de la compra.',

    /* ---- carrito ---- */
    'YOUR CART': 'TU CARRITO',
    'Cart': 'Carrito',
    'Your cart is empty.': 'Tu carrito está vacío.',
    'Product': 'Producto',
    'Qty': 'Cant.',
    'Total': 'Total',
    'Remove': 'Quitar',
    'Subtotal': 'Subtotal',
    'Taxes and discounts calculated at checkout.': 'Impuestos y descuentos se calculan en el checkout.',
    'Update': 'Actualizar',
    'Checkout': 'Finalizar compra',

    /* ---- contacto ---- */
    'GET IN TOUCH': 'ESCRIBINOS',
    'Contact': 'Contacto',
    'Name': 'Nombre',
    'Email': 'Email',
    'Subject': 'Asunto',
    'General question': 'Consulta general',
    'Licensing': 'Licencias',
    'Technical support': 'Soporte técnico',
    'Press / partnerships': 'Prensa / alianzas',
    'Message': 'Mensaje',
    'Send message': 'Enviar mensaje',
    'Message sent': 'Mensaje enviado',
    'Thanks, we usually reply within one business day.': 'Gracias, solemos responder dentro de un día hábil.',
    'Installation, licensing and bug reports. Check the FAQ first.': 'Instalación, licencias y reportes de errores. Mirá primero las FAQ.',
    'Response time': 'Tiempo de respuesta',
    'Within one business day, Monday to Friday.': 'Dentro de un día hábil, de lunes a viernes.',
    'Follow': 'Seguinos',

    /* ---- catálogo ---- */
    'CATALOGUE': 'CATÁLOGO',
    'Newsletter': 'Novedades',
    'All products': 'Todos los productos',
    'Plugins & tools': 'Plugins y herramientas',
    'Nothing here yet.': 'Todavía no hay nada acá.',
    'View': 'Ver',
    'From': 'Desde',

    /* ---- licencias ---- */
    'YOUR LICENSES': 'TUS LICENCIAS',
    'Licenses': 'Licencias',
    'Your SID licenses and the machines each one is activated on. Releasing a machine frees the slot for another computer.': 'Tus licencias de SID y las máquinas donde está activada cada una. Liberar una máquina deja el lugar libre para otra computadora.',
    'Loading…': 'Cargando…',

    /* ---- descargas ---- */
    'DOWNLOADS': 'DESCARGAS',
    'Downloads': 'Descargas',
    'Download': 'Descargar',
    'Version': 'Versión',
    'Installers, presets and release notes.': 'Instaladores, presets y notas de versión.',
    'No downloads yet.': 'Todavía no hay descargas.'
  };

  var ES_ATTR = {
    'Language': 'Idioma',
    'Menu': 'Menú',
    'Previous reviews': 'Reviews anteriores',
    'Next reviews': 'Reviews siguientes',
    'Close': 'Cerrar',
    'Email address': 'Dirección de email',
    'Subscribe': 'Suscribirse',
    'SID plugin interface: pattern sidechain with editable envelope curve and 16 step lanes': 'Interfaz del plugin SID: pattern sidechain con curva de envolvente editable y 16 pasos'
  };

  var LANG_KEY = 'di-lang';
  var EN_CACHE = new WeakMap();

  function walkText(root, fn) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest('[data-di-no-i18n]')) return NodeFilter.FILTER_REJECT;
        /* los que traen su propia traduccion se resuelven aparte, no por diccionario */
        if (p.closest && p.closest('[data-di-es]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = w.nextNode())) fn(n);
  }

  /* Traduccion explicita por elemento. El diccionario solo sirve para copy que
     escribimos nosotros; los links del menu salen de la navegacion de Shopify y
     pueden decir cualquier cosa, asi que cada uno viaja con su propio ES. */
  function applyDirect(toEs) {
    document.querySelectorAll('[data-di-es]').forEach(function (el) {
      if (el.dataset.diEnText == null) el.dataset.diEnText = el.textContent;
      var es = el.dataset.diEs;
      el.textContent = toEs && es ? es : el.dataset.diEnText;
    });
  }

  function applyLang(lang) {
    var toEs = lang === 'es';
    applyDirect(toEs);
    walkText(document.body, function (node) {
      if (!EN_CACHE.has(node)) EN_CACHE.set(node, node.nodeValue);
      var en = EN_CACHE.get(node);
      if (!toEs) { node.nodeValue = en; return; }
      var key = en.trim();
      if (Object.prototype.hasOwnProperty.call(ES, key)) {
        node.nodeValue = en.replace(key, ES[key]);
      }
    });

    document.querySelectorAll('[aria-label],[placeholder],[alt]').forEach(function (el) {
      ['aria-label', 'placeholder', 'alt'].forEach(function (a) {
        if (!el.hasAttribute(a)) return;
        var store = 'diEn' + a.replace('-', '');
        if (!el.dataset[store]) el.dataset[store] = el.getAttribute(a);
        var en = el.dataset[store];
        el.setAttribute(a, toEs && ES_ATTR[en] ? ES_ATTR[en] : en);
      });
    });

    document.documentElement.lang = toEs ? 'es' : 'en';
    document.querySelectorAll('[data-di-lang]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.diLang === lang));
    });
    try { localStorage.setItem(LANG_KEY, lang); } catch (e) {}
  }

  function initLang() {
    var saved = null;
    try { saved = localStorage.getItem(LANG_KEY); } catch (e) {}
    applyLang(saved === 'es' ? 'es' : 'en');
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-di-lang]');
      if (b) applyLang(b.dataset.diLang);
    });
  }

  /* --------------------------------------------------------------- reveal */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ FAQ */
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-di-faq]');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
      var sign = btn.querySelector('[data-di-faq-sign]');
      if (sign) sign.textContent = open ? '+' : '−';
    });
  }

  /* -------------------------------------------------- comparador de audio
     Puede haber más de un comparador en la página: el del hero (celular) y
     el de specs (desktop). Nunca se ven dos a la vez. Cada uno es un
     reproductor independiente; los botones [data-di-play] sueltos, como el
     flotante, controlan el que esté a la vista. Solo suena uno por vez. */
  var players = [];
  var lastPlayer = null;
  var audioWired = false;

  function isShown(el) { return !!(el && el.offsetParent !== null); }

  function activePlayer() {
    if (lastPlayer && isShown(lastPlayer.root)) return lastPlayer;
    for (var i = 0; i < players.length; i++) {
      if (isShown(players[i].root)) return players[i];
    }
    return players[0] || null;
  }

  function pauseOthers(p) {
    players.forEach(function (o) { if (o !== p && !o.audio.paused) o.audio.pause(); });
  }

  function refreshPlayButtons() {
    var act = activePlayer();
    document.querySelectorAll('[data-di-play]').forEach(function (b) {
      var own = b.closest('[data-di-audio]');
      var p = own ? own.__diPlayer : act;
      var playing = !!(p && !p.audio.paused);
      b.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      b.classList.toggle('is-playing', playing);
      var bars = b.querySelector('.di-vu');
      if (bars) bars.classList.toggle('di-vu--anim', playing);
      var txt = b.querySelector('[data-di-play-text]');
      if (txt) txt.textContent = playing ? 'PAUSE' : 'PLAY';
    });
  }

  function createPlayer(root) {
    var audio = root.querySelector('audio');
    if (!audio) return null;

    /* Liquid emite el mapa "track-modo" -> asset_url, porque cada asset de
       Shopify lleva su propio ?v= y no se puede armar la URL por string */
    var map = {};
    try { map = JSON.parse(root.dataset.diAudioMap || '{}'); } catch (e) {}
    var tpl = root.dataset.diAudioBase || '';
    var p = {
      root: root,
      audio: audio,
      track: root.dataset.diAudioTrack || '1',
      mode: root.dataset.diAudioMode || 'sid'
    };

    function srcFor(t, m) {
      var k = t + '-' + m;
      return map[k] || (tpl ? tpl.replace('__FILE__', k) : '');
    }

    function sync() {
      root.querySelectorAll('[data-di-track]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.diTrack === p.track));
      });
      root.querySelectorAll('[data-di-mode]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.diMode === p.mode));
      });
    }

    /* conserva la posicion de reproduccion al cambiar de pista o modo:
       es lo que hace que la comparacion A/B sea util */
    function swap(t, m, autoplay) {
      if (!srcFor(t, m)) return;   /* audio todavia no subido: no rompas el player */
      var pos = audio.currentTime || 0;
      var shouldPlay = autoplay || !audio.paused;
      p.track = t;
      p.mode = m;
      root.dataset.diAudioTrack = t;
      root.dataset.diAudioMode = m;
      audio.src = srcFor(t, m);

      var onMeta = function () {
        audio.removeEventListener('loadedmetadata', onMeta);
        try {
          audio.currentTime = audio.duration ? Math.min(pos, audio.duration) : pos;
        } catch (e) {}
        if (shouldPlay) {
          pauseOthers(p);
          audio.play().catch(function () {});
        }
      };
      audio.addEventListener('loadedmetadata', onMeta);
      audio.load();
      sync();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-di-track]');
      if (t) { lastPlayer = p; swap(t.dataset.diTrack, p.mode, true); return; }
      var m = e.target.closest('[data-di-mode]');
      if (m) { lastPlayer = p; swap(p.track, m.dataset.diMode, true); }
    });

    audio.addEventListener('play', function () {
      pauseOthers(p);
      lastPlayer = p;
      refreshPlayButtons();
    });
    audio.addEventListener('pause', refreshPlayButtons);

    /* si faltan los mp3 el bloque queda visible pero inerte, en vez de
       tirar errores de red */
    var initial = srcFor(p.track, p.mode);
    if (initial) audio.src = initial;
    else root.setAttribute('data-di-audio-missing', '');
    sync();

    root.__diPlayer = p;
    return p;
  }

  function initAudio() {
    /* el editor de temas re-renderiza secciones: se descartan los
       reproductores cuyo nodo ya no está y se crean los nuevos */
    players = players.filter(function (p) { return document.documentElement.contains(p.root); });
    document.querySelectorAll('[data-di-audio]').forEach(function (root) {
      if (root.__diPlayer) return;
      var p = createPlayer(root);
      if (p) players.push(p);
    });

    /* una sola vez: antes cada shopify:section:load sumaba otro listener
       global y el boton de play terminaba haciendo play+pause */
    if (!audioWired) {
      audioWired = true;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-di-play]');
        if (!b) return;
        var own = b.closest('[data-di-audio]');
        var p = own ? own.__diPlayer : activePlayer();
        if (!p) return;
        if (p.audio.paused) {
          pauseOthers(p);
          lastPlayer = p;
          p.audio.play().catch(function () {});
        } else {
          p.audio.pause();
        }
      });

      /* al rotar el telefono o cambiar el ancho, el reproductor que queda
         oculto se pausa: no puede seguir sonando algo que no se ve */
      var mq = window.matchMedia('(max-width: 749px)');
      var onBreakpoint = function () {
        players.forEach(function (p) { if (!isShown(p.root) && !p.audio.paused) p.audio.pause(); });
        refreshPlayButtons();
      };
      if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
      else if (mq.addListener) mq.addListener(onBreakpoint);
    }

    refreshPlayButtons();
  }

  /* ------------------------------------------ barra de compra (celular)
     Aparece recién cuando el botón GET SID del hero salió de pantalla por
     arriba, y se va apenas vuelve a verse. También se va mientras se ve el
     GET SID del detalle: nunca hay dos GET SID a la vez.
     Mientras se ven los controles propios del hero (su play y su GET SID)
     se oculta el PLAY flotante, que ahí sobraba y tapaba contenido.
     Todo con IntersectionObserver, sin escuchar el scroll.
     El breakpoint va por matchMedia, no por detección de dispositivo. */
  var sticky = { io: null, mq: null, wired: false };

  function initSticky() {
    var bar = document.querySelector('[data-di-sticky]');
    var html = document.documentElement;
    if (sticky.io) { sticky.io.disconnect(); sticky.io = null; }

    if (!bar) {
      html.classList.remove('di-has-sticky', 'di-sticky-visible', 'di-hero-controls');
      return;
    }

    var mq = sticky.mq || (sticky.mq = window.matchMedia('(max-width: 749px)'));
    var slice = Array.prototype.slice;
    /* el botón GET SID en sí, no todo el bloque: la prueba y las
       aclaraciones de abajo no cuentan como "el CTA está a la vista" */
    var buys = slice.call(document.querySelectorAll('.di-buygroup .di-buylink:not(.di-trybtn)'));
    var own = slice.call(document.querySelectorAll('.di-buygroup--hero, .di-ab--compact'));
    var watched = buys.concat(own.filter(function (el) { return buys.indexOf(el) < 0; }));
    var shown = [];

    function visible(el) { return shown[watched.indexOf(el)] === true; }

    function update() {
      var first = buys[0];
      var passed = first ? first.getBoundingClientRect().bottom < 0 : false;
      var show = mq.matches && passed && !buys.some(visible);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      html.classList.toggle('di-sticky-visible', show);
      html.classList.toggle('di-hero-controls', mq.matches && own.some(visible));
    }

    function setup() {
      html.classList.toggle('di-has-sticky', mq.matches);
      if (sticky.io) { sticky.io.disconnect(); sticky.io = null; }
      shown = watched.map(function () { return false; });
      if (mq.matches && 'IntersectionObserver' in window && watched.length) {
        sticky.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var i = watched.indexOf(en.target);
            if (i > -1) shown[i] = en.isIntersecting;
          });
          update();
        });
        watched.forEach(function (t) { sticky.io.observe(t); });
      }
      update();
    }

    if (!sticky.wired) {
      sticky.wired = true;
      if (mq.addEventListener) mq.addEventListener('change', function () { initSticky(); });
      else if (mq.addListener) mq.addListener(function () { initSticky(); });
    }
    setup();
  }

  /* ------------------------------------------------------ menú (celular)
     La hamburguesa solo abre y cierra: adentro están los mismos links,
     carrito, cuenta y botones de idioma de siempre, con su lógica de
     siempre. Mientras está abierto, lo que queda atrás pasa a inert (sin
     foco ni clicks) y el scroll se bloquea con el atributo scroll-lock
     que ya usa Horizon. Se cierra con la X, tocando fuera, con Escape,
     al elegir un link o si la pantalla deja de ser de celular. */
  var menu = { btn: null, panel: null, nav: null, open: false, inertos: [], wired: false };

  function liberarFondo() {
    menu.inertos.forEach(function (el) { el.inert = false; });
    menu.inertos = [];
    document.documentElement.removeAttribute('scroll-lock');
  }

  function setMenu(open, devolverFoco) {
    if (!menu.btn || menu.open === open) return;
    menu.open = open;
    menu.btn.setAttribute('aria-expanded', String(open));
    menu.nav.classList.toggle('is-menu-open', open);

    if (!open) {
      liberarFondo();
      if (devolverFoco) menu.btn.focus({ preventScroll: true });
      return;
    }

    /* el header no es fijo: si quedó a medias fuera de pantalla, se trae
       arriba antes de bloquear el scroll, así el panel se ve entero */
    var arriba = menu.nav.getBoundingClientRect().top;
    if (arriba < 0) window.scrollTo(0, window.pageYOffset + arriba);

    document.documentElement.setAttribute('scroll-lock', '');
    /* de la nav hacia arriba, todo hermano queda inert: main, footer,
       barra de compra, play flotante */
    for (var el = menu.nav; el.parentElement && el !== document.body; el = el.parentElement) {
      Array.prototype.forEach.call(el.parentElement.children, function (sib) {
        if (sib === el || sib.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sib.tagName)) return;
        sib.inert = true;
        menu.inertos.push(sib);
      });
    }
    var first = menu.panel.querySelector('a[href], button');
    if (first) first.focus({ preventScroll: true });
  }

  function initMenu() {
    /* el editor puede re-renderizar el header con el menú abierto */
    if (menu.open) { liberarFondo(); menu.open = false; }

    var btn = document.querySelector('[data-di-menu-toggle]');
    menu.btn = btn;
    menu.nav = btn ? btn.closest('.di-nav') : null;
    menu.panel = btn ? document.getElementById(btn.getAttribute('aria-controls')) : null;
    if (!menu.nav || !menu.panel) menu.btn = null;

    if (menu.wired) return;
    menu.wired = true;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-di-menu-toggle]')) { setMenu(!menu.open, false); return; }
      if (!menu.open) return;
      if (e.target.closest('[data-di-menu-close]')) { setMenu(false, true); return; }
      /* links del menú (también #sid y #faq): se cierra antes de que el
         navegador salte, para que el scroll ya esté liberado */
      if (e.target.closest('[data-di-menu] a[href]')) setMenu(false, false);
    });

    document.addEventListener('keydown', function (e) {
      if (menu.open && (e.key === 'Escape' || e.key === 'Esc')) setMenu(false, true);
    });

    var mq = window.matchMedia('(max-width: 749px)');
    var alCambiar = function () { if (!mq.matches) setMenu(false, false); };
    if (mq.addEventListener) mq.addEventListener('change', alCambiar);
    else if (mq.addListener) mq.addListener(alCambiar);
  }

  /* ------------------------------------------------ reviews (carrusel)
     Scroll nativo con scroll-snap: las flechas, el arrastre con el mouse y
     el avance automático solo empujan el scroll. Sin librerías.
     El avance automático se corta apenas el visitante toca el carrusel. */
  function initCarousels() {
    var lento = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-di-carousel]').forEach(function (car) {
      if (car.__diCarousel) return;
      car.__diCarousel = true;

      var track = car.querySelector('[data-di-carousel-track]');
      var nav = car.querySelector('[data-di-carousel-nav]');
      var prev = car.querySelector('[data-di-carousel-prev]');
      var next = car.querySelector('[data-di-carousel-next]');
      if (!track) return;

      var seg = (Number(car.dataset.diAutoplay) || 0) * 1000;
      var timer = null;
      var cortado = false;   /* el visitante ya tomó el control */

      function enPantalla() {
        var r = car.getBoundingClientRect();
        return r.bottom > 0 && r.top < (window.innerHeight || 0);
      }

      function paso() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function resto() { return track.scrollWidth - track.clientWidth - track.scrollLeft; }
      function mover(d) {
        track.scrollBy({ left: d, behavior: lento.matches ? 'auto' : 'smooth' });
      }
      function refrescar() {
        var hay = track.scrollWidth > track.clientWidth + 4;
        if (nav) nav.hidden = !hay;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = resto() <= 2;
      }
      function avanzar() {
        if (resto() <= 2) track.scrollTo({ left: 0, behavior: lento.matches ? 'auto' : 'smooth' });
        else mover(paso());
      }
      function arrancar() {
        if (timer || cortado || !seg || lento.matches) return;
        /* solo avanza si la sección está a la vista y hay algo que deslizar */
        timer = setInterval(function () {
          if (document.hidden || !enPantalla()) return;
          if (track.scrollWidth > track.clientWidth + 4) avanzar();
        }, seg);
      }
      function cortar() {
        cortado = true;
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (prev) prev.addEventListener('click', function () { cortar(); mover(-paso()); });
      if (next) next.addEventListener('click', function () { cortar(); mover(paso()); });
      track.addEventListener('scroll', refrescar, { passive: true });
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(function (ev) {
        track.addEventListener(ev, cortar, { passive: true });
      });
      window.addEventListener('resize', refrescar);

      /* arrastre con el mouse; en pantallas táctiles ya lo hace el sistema */
      var arrastre = null;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrastre = { x: e.clientX, left: track.scrollLeft, movido: false };
      });
      track.addEventListener('pointermove', function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        if (!arrastre.movido && Math.abs(dx) < 4) return;
        if (!arrastre.movido) { arrastre.movido = true; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId); }
        track.scrollLeft = arrastre.left - dx;
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        track.addEventListener(ev, function (e) {
          if (!arrastre) return;
          if (arrastre.movido) {
            track.classList.remove('is-dragging');
            /* al soltar, que el snap acomode la card más cercana */
            track.scrollTo({ left: Math.round(track.scrollLeft / paso()) * paso(), behavior: lento.matches ? 'auto' : 'smooth' });
            try { track.releasePointerCapture(e.pointerId); } catch (err) {}
          }
          arrastre = null;
        });
      });
      /* un arrastre no debe abrir el link de Instagram de la card */
      track.addEventListener('click', function (e) {
        if (track.classList.contains('is-dragging')) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      refrescar();
      arrancar();
    });
  }

  /* ------------------------------------------------- modal de la review
     <dialog> nativo: trae foco atrapado, Escape y fondo. Si el navegador
     es viejo y no tiene showModal, se abre igual con una clase. */
  var modalAbridor = null;

  function abrirModal(m, abridor) {
    if (m.open) return;
    modalAbridor = abridor || document.activeElement;
    if (m.showModal) m.showModal();
    else { m.setAttribute('open', ''); m.classList.add('is-open'); }
    var primero = m.querySelector('input, textarea, button:not([data-di-review-close])');
    if (primero) primero.focus({ preventScroll: true });
  }

  function cerrarModal(m) {
    if (!m.open) return;
    if (m.close) m.close();
    else { m.removeAttribute('open'); m.classList.remove('is-open'); }
    if (modalAbridor && modalAbridor.focus) modalAbridor.focus({ preventScroll: true });
    modalAbridor = null;
  }

  function initReviewModal() {
    var m = document.querySelector('[data-di-review-modal]');
    if (!m) return;

    if (!m.__diModal) {
      m.__diModal = true;
      /* clic en el fondo (el evento cae en el propio <dialog>) */
      m.addEventListener('click', function (e) { if (e.target === m) cerrarModal(m); });
      m.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && !m.showModal) cerrarModal(m);
      });
      var form = m.querySelector('form');
      if (form) form.addEventListener('submit', function () {
        var b = form.querySelector('[data-di-review-submit]');
        if (!b) return;
        b.disabled = true;
        if (b.dataset.diSending) b.textContent = b.dataset.diSending;
      });
    }

    if (!document.__diModalWired) {
      document.__diModalWired = true;
      document.addEventListener('click', function (e) {
        var abrir = e.target.closest('[data-di-review-open]');
        if (abrir) {
          var modal = document.querySelector('[data-di-review-modal]');
          if (modal) abrirModal(modal, abrir);
          return;
        }
        if (e.target.closest('[data-di-review-close]')) {
          var cerrar = e.target.closest('[data-di-review-modal]');
          if (cerrar) cerrarModal(cerrar);
        }
      });
    }

    /* volvió del envío: se reabre para mostrar el resultado */
    if (m.querySelector('[data-di-review-state]')) abrirModal(m);
  }

  /* ------------------------------------------------- página de producto */
  function initProduct() {
    var root = document.querySelector('[data-di-product]');
    if (!root) return;
    var sel = root.querySelector('select[name="id"]');
    if (!sel) return;   /* variante única: no hay nada que actualizar */

    var data = root.querySelector('[data-di-variant-data]');
    var map = {};
    try { map = JSON.parse(data ? data.textContent : '{}'); } catch (e) { return; }

    var price = root.querySelector('[data-di-price]');
    var was = root.querySelector('[data-di-was]');
    var add = root.querySelector('[data-di-add]');

    sel.addEventListener('change', function () {
      var v = map[sel.value];
      if (!v) return;
      if (price) price.textContent = v.price;
      if (was) {
        was.textContent = v.compare || '';
        was.hidden = !v.compare;
      }
      if (add) add.disabled = !v.available;
    });
  }

  function boot() {
    initTheme();
    initLang();
    initReveal();
    initFaq();
    initAudio();
    initSticky();
    initMenu();
    initCarousels();
    initReviewModal();
    initProduct();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* el editor de temas re-renderiza secciones sueltas sin recargar la pagina */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initAudio();
    initSticky();
    initMenu();
    initCarousels();
    initReviewModal();
  });
})();
